(() => {
  const initHero = (hero) => {
    if (!hero || hero.dataset.cgV2HeroInitialized === 'true') {
      return;
    }

    const slides = Array.from(hero.querySelectorAll('[data-cg-v2-hero-slide]'));
    const previous = hero.querySelector('[data-cg-v2-hero-previous]');
    const next = hero.querySelector('[data-cg-v2-hero-next]');
    const status = hero.querySelector('[data-cg-v2-hero-status]');

    if (!slides.length) {
      return;
    }

    hero.dataset.cgV2HeroInitialized = 'true';
    let activeIndex = Number.parseInt(hero.dataset.activeIndex || '0', 10);

    if (!Number.isInteger(activeIndex) || activeIndex < 0 || activeIndex >= slides.length) {
      activeIndex = 0;
    }

    const render = () => {
      slides.forEach((slide, index) => {
        const isActive = index === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      hero.dataset.activeIndex = String(activeIndex);

      if (status) {
        const label = slides[activeIndex].dataset.slideLabel || `Slide ${activeIndex + 1}`;
        status.textContent = `${label}. Slide ${activeIndex + 1} of ${slides.length}.`;
      }
    };

    const move = (direction) => {
      if (slides.length < 2) {
        return;
      }

      activeIndex = (activeIndex + direction + slides.length) % slides.length;
      render();
    };

    previous?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));

    render();
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-cg-v2-hero]').forEach(initHero);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
